import React, { useCallback } from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  Input, Select, Spin, Form,
} from 'antd';
import { debounce } from 'lodash';
import {
  getPermissions,
} from '../../redux/actions/Auth';
import { handleSearch } from '../../util/table';

const { Option } = Select;
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const RoleForm = ({
  form, selectedPermissions, setSelectedPermissions, setselectedType, selectedType,
}) => {
  const dispatch = useDispatch();
  const {
    searchResults: permissions, searching,
  } = useSelector(({ auth }) => auth.permissions);

  const debouncedSearch = useCallback(
    debounce((nextValue) => handleSearch(
      nextValue, dispatch, getPermissions, () => [{ dataIndex: 'name' }], { search: true },
    ), 1000),
    [],
  );

  const permissionsSearch = (value) => {
    debouncedSearch(value);
  };

  const options = permissions.length
  && permissions.map((permission) => <Option key={permission._id}>{permission.name}</Option>);

  return (
    <Form
      name="role-form"
      className="gx-form-row0"
      ref={form}
      {...formItemLayout}
    >
      <Form.Item
        rules={[
          { required: true, message: 'This input is required!' },
        ]}
        label="Role"
        name="name"
      >
        <Input placeholder="Role" />
      </Form.Item>
      <Form.Item
        label="Role Type"
      >
        <Select placeholder="Select type" onChange={setselectedType} value={selectedType}>
          <Option key="role_type_1" value="is_system_role">System Role</Option>
          <Option key="role_type_2" value="is_merchant">Merchant Role</Option>
        </Select>
      </Form.Item>
      <Form.Item
        label="Permissions"
      >
        <Select
          mode="multiple"
          allowClear
          showArrow
          style={{ width: '100%' }}
          placeholder="Please select permissions"
          filterOption={false}
          value={selectedPermissions}
          onChange={setSelectedPermissions}
          onSearch={permissionsSearch}
          notFoundContent={searching ? <Spin size="small" /> : 'No types found'}
          maxTagCount="responsive"

        >
          {options}
        </Select>
      </Form.Item>
    </Form>
  );
};

RoleForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  selectedPermissions: PropTypes.oneOfType([
    PropTypes.array,
  ]),
  selectedType: PropTypes.string,
  setSelectedPermissions: PropTypes.func.isRequired,
  setselectedType: PropTypes.func.isRequired,
};

RoleForm.defaultProps = {
  form: {},
  selectedPermissions: [],
  selectedType: null,
};

export default RoleForm;
